"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../elements/button/Button");
var _brands = require("../../utils/brands/brands");
var _MinusOutlined = require("../icons/MinusOutlined");
var _PlusOutlined = require("../icons/PlusOutlined");
var _colourModule = _interopRequireDefault(require("./colour.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["brand", "hasDiorPromosEnabled", "children", "label", "showMore", "hideLabel", "selectedLabel", "onClick", "name", "containerClassName", "containerProps", "headingLevel"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  /** Brand name of the product */
  brand: _propTypes.default.string,
  /** Feature flag for Dior Promo changes */
  hasDiorPromosEnabled: _propTypes.default.bool,
  /** Colours to be displayed within the list */
  children: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
  /** Truncate list and provide a 'show more' button after X colours */
  showMore: _propTypes.default.number,
  /** Name of the group */
  label: _propTypes.default.string,
  /** Function to be called when a size is selected */
  onClick: _propTypes.default.func,
  /** Name of the selected Colour */
  selectedLabel: _propTypes.default.string,
  /** Specifies the heading level to use for the label */
  headingLevel: _propTypes.default.oneOf(['h2', 'h3', 'h4', 'h5', 'h6'])
};
var ColourList = function ColourList(_ref) {
  var brand = _ref.brand,
    _ref$hasDiorPromosEna = _ref.hasDiorPromosEnabled,
    hasDiorPromosEnabled = _ref$hasDiorPromosEna === void 0 ? false : _ref$hasDiorPromosEna,
    children = _ref.children,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Colour' : _ref$label,
    _ref$showMore = _ref.showMore,
    showMore = _ref$showMore === void 0 ? 6 : _ref$showMore,
    hideLabel = _ref.hideLabel,
    selectedLabel = _ref.selectedLabel,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'colour' : _ref$name,
    containerClassName = _ref.containerClassName,
    _ref$containerProps = _ref.containerProps,
    containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
    _ref$headingLevel = _ref.headingLevel,
    Heading = _ref$headingLevel === void 0 ? 'h4' : _ref$headingLevel,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isDior = (0, _brands.isDiorBrand)(brand) && hasDiorPromosEnabled;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowingMore = _useState2[0],
    setIsShowingMore = _useState2[1];
  if (!children || children.length === 0) {
    return null;
  }
  var numberHiddenControls = children.length - showMore;
  var canShowMore = children.length > showMore;
  var renderedLabel = selectedLabel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectorLabel, {
    headingLevel: Heading,
    label: label,
    selectedLabel: selectedLabel
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Heading, {
    className: _colourModule.default['c-colourList__title'],
    "data-testid": "colourlist:label",
    children: label
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: (0, _classnames.default)(_colourModule.default['c-colourList'], containerClassName)
  }, containerProps), {}, {
    "data-jlds": true,
    children: [hideLabel ? null : renderedLabel, /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: (0, _classnames.default)(_colourModule.default["c-colourList__items"], _colourModule.default["c-colourList__items--three"]),
      children: children.map(function (child, i) {
        if (isShowingMore || !isShowingMore && i < showMore) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            children: /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread({
              name: name,
              onClick: onClick,
              isDior: isDior
            }, rest))
          }, child.props.value);
        }
        return null;
      })
    }), canShowMore && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _colourModule.default.showMoreContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.TertiaryButton, {
        IconComponent: isShowingMore ? _MinusOutlined.MinusOutlined : _PlusOutlined.PlusOutlined,
        className: _colourModule.default.showMoreButton,
        iconPositionRight: true,
        onClick: function onClick() {
          setIsShowingMore(!isShowingMore);
        },
        small: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: _colourModule.default.showMoreButtonText,
          children: [!isShowingMore && "Show ".concat(numberHiddenControls, " more"), isShowingMore && "Show less"]
        })
      })
    })]
  }));
};
var SelectorLabel = function SelectorLabel(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? 'Colour' : _ref2$label,
    _ref2$headingLevel = _ref2.headingLevel,
    Heading = _ref2$headingLevel === void 0 ? 'h4' : _ref2$headingLevel,
    selectedLabel = _ref2.selectedLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Heading, {
    className: _colourModule.default['c-colourList__title'],
    "data-testid": "colourlist:label",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _colourModule.default['c-colourList__label'],
      children: "".concat(label, ": ")
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _colourModule.default['c-colourList__selected'],
      children: selectedLabel
    })]
  });
};
SelectorLabel.propTypes = {
  /** Name of the label */
  label: _propTypes.default.string,
  /** Name of the selected value */
  selectedLabel: _propTypes.default.string.isRequired,
  /** Specifies the heading level to use for the label */
  headingLevel: _propTypes.default.oneOf(['h2', 'h3', 'h4', 'h5', 'h6'])
};
ColourList.propTypes = propTypes;
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(ColourList);